"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalMarkupOptions = void 0;
const useGlobalMarkupOptions_1 = __importDefault(require("./useGlobalMarkupOptions"));
/**
 * Component GlobalMarkupOptions accepts an object as `children`, which behaves exactly as the `nlOpts` option to nw-app-module.
 * See https://github.com/NerdWallet/nw-app-module#globalmarkupoptions-component-or-useglobalmarkupoptions-hook for documentation on usage.
 * The component renders nothing.
 */
const GlobalMarkupOptions = ({ children, }) => {
    (0, useGlobalMarkupOptions_1.default)(children);
    return null;
};
exports.GlobalMarkupOptions = GlobalMarkupOptions;
//# sourceMappingURL=GlobalMarkupOptions.js.map